export enum SolutionTypeEnum {
  VODARENSTVO = "vodarenstvo",
  PRIEMYSEL = "priemysel",
  ENERGETIKA = "energetika",
  OBNOVITELNE_ZDROJE_ENERGIE = "obnovitelne_zdroje_energie",
  FONTANY = "fontany",
  SERVIS_A_TECHNICKA_SPRAVA = "servis_a_technicka_sprava",
}
